<template>
  <div>
    <div class="nav-wrap" :class="{'scrolled': scrolled }">
      <nav id="main-header">
        <div class="nav-inner clearfix complex">
          <div class="top-bar">
            <router-link :to="{ name: 'home'}" class="logo">
              <img class="hidden-sm" src="../../images/remembear-logo.svg" alt="RememBear Home">
              <img class="visible-sm" src="../../images/r.svg" alt="RememBear Home">
            </router-link>
            <button @click="menuVisible = !menuVisible" class="menu visible-sm">Menu</button>
          </div>
          <div id="nav-items" class="list" :class="{'mobile-visible': menuVisible}">
            <div class="nav-state PUBLIC">
              <ul>
                <li>
                  <a href="https://help.remembear.com">Help</a>
                </li>
                <li>
                  <a :href="ENV.blogURL">Blog</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="nav-inner minimal">
          <div class="top-bar">
            <router-link :to="{ name: 'home'}" class="logo">
              <img src="../../images/remembear-logo.svg" alt="RememBear Beta Home">
            </router-link>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import services from '../../services/services.js'
import is from 'is_js'

export default {
  name: 'site-navigation',
  data () {
    return {
      is: is,
      menuVisible: false,
      scrolled: false
    }
  },
  created: function () {
    window.addEventListener('scroll', this.calculateNavState)
  },
  methods: {
    calculateNavState: function () {
      if (services.windowScrollTop() > 50) {
        if (this.scrolled) return
        this.scrolled = true
      } else {
        if (!this.scrolled) return
        this.scrolled = false
      }
    },
    logout: function () {
      window.location.href = this.ENV.apiBaseUrl + '/web/account/logout'
    }
  },
  computed: {
    loggedIn: function () {
      return this.$store.state.isLoggedIn
    }
  },
  watch: {
    '$route' (to, from) {
      this.menuVisible = false
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', this.calculateNavState)
  }
}
</script>

<style scoped lang="stylus" src="./nav.styl" >



// WEBPACK FOOTER //
// src/components/nav/nav.vue